export default "__VITE_ASSET__dafbfa1f__"